import { gql } from '@apollo/client'

export const CORE_SHIFT_FIELDS = gql`
  fragment ShiftFields on Shift {
    id
    clientId
    storeId
    storeName
    userId
    employee {
      id
      meta
    }
    clockedInAt
    clockedOutAt
    clockedInBy {
      id
      meta
    }
    clockedOutBy {
      id
      meta
    }
    isDeleted
    changeLog {
      updatedAt
      changeAuthor {
        id
        meta
      }
      changedShiftFields
    }
  }
`

export const SHIFTS_DATA = gql`
  ${CORE_SHIFT_FIELDS}
  query GetShifts {
    shifts(params: {}) {
      ...ShiftFields
    }
  }
`

export const GET_ALL_SHIFTS = gql`
  ${CORE_SHIFT_FIELDS}
  query GetAllShifts(
    $storeIds: [ID]
    $clientId: ID
    $userIds: [ID]
    $startDate: Date
    $endDate: Date
    $includeDeleted: Boolean
    $orderBy: ShiftsOrderBy
    $orderDirection: OrderDirection
    $limit: Int = 100
    $offset: Int = 0
  ) {
    shifts(
      params: {
        storeIds: $storeIds
        clientId: $clientId
        userIds: $userIds
        startDate: $startDate
        endDate: $endDate
        includeDeleted: $includeDeleted
        orderBy: $orderBy
        orderDirection: $orderDirection
        limit: $limit
        offset: $offset
      }
    ) {
      ...ShiftFields
    }
    pagination @client {
      total
    }
  }
`

export const GET_OWN_SHIFTS = gql`
  ${CORE_SHIFT_FIELDS}
  query GetOwnShifts(
    $shiftId: ID
    $storeIds: [ID]
    $clientId: ID
    $userIds: [ID]
    $startDate: Date
    $endDate: Date
    $includeDeleted: Boolean
    $orderBy: ShiftsOrderBy
    $orderDirection: OrderDirection
    $limit: Int = 100
    $offset: Int = 0
  ) {
    shifts: ownShifts(
      params: {
        shiftId: $shiftId
        storeIds: $storeIds
        clientId: $clientId
        userIds: $userIds
        startDate: $startDate
        endDate: $endDate
        includeDeleted: $includeDeleted
        orderBy: $orderBy
        orderDirection: $orderDirection
        limit: $limit
        offset: $offset
      }
    ) {
      ...ShiftFields
    }
    pagination @client {
      total
    }
  }
`

export const GET_ONE_SHIFT = gql`
  ${CORE_SHIFT_FIELDS}
  query GetOneShift($id: ID!) {
    shift(id: $id) {
      ...ShiftFields
    }
  }
`
export const UPSERT_SHIFT = gql`
  ${CORE_SHIFT_FIELDS}
  mutation UpsertShift(
    $id: ID
    $clientId: ID
    $storeId: ID
    $userId: ID
    $clockedInAt: Time
    $clockedInById: ID
    $clockedOutAt: Time
    $clockedOutById: ID
    $isDeleted: Boolean
    $updatedById: ID
  ) {
    upsertShift(
      shift: {
        id: $id
        clientId: $clientId
        storeId: $storeId
        userId: $userId
        clockedInAt: $clockedInAt
        clockedInById: $clockedInById
        clockedOutAt: $clockedOutAt
        clockedOutById: $clockedOutById
        isDeleted: $isDeleted
        updatedById: $updatedById
      }
    ) {
      ...ShiftFields
    }
  }
`
export const CLOCK_USER_OUT = gql`
  mutation ClockUserOut($userId: ID!, $shiftId: ID, $storeId: ID) {
    clockUserOut(userId: $userId, shiftId: $shiftId, storeId: $storeId) {
      clockedOutAt
      clockedOutBy {
        meta
      }
      changeLog {
        updatedAt
        changeAuthor {
          meta
        }
        changedShiftFields
      }
    }
  }
`

export const CLOCK_OUT_OWN_USER = gql`
  ${CORE_SHIFT_FIELDS}
  mutation ClockOutOwnUser {
    clockOutOwnUser {
      ...ShiftFields
    }
  }
`

export const CLOCK_IN_OWN_USER = gql`
  ${CORE_SHIFT_FIELDS}
  mutation ClockInOwnUser {
    clockInOwnUser {
      ...ShiftFields
    }
  }
`
